module.exports = __webpack_public_path__ + "img/ic-card-white.d4edf9fa.svg";